"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var grid_1 = require("./grid");
var Carousel_1 = __importDefault(require("./Carousel"));
var spacing_1 = require("./spacing");
var Stars_1 = __importDefault(require("./Stars"));
var typography_1 = require("./typography");
var testimonials = [
    {
        review: 'I registered for my father and he’s been having Rachael clean his home every other week. He likes it, it’s going well. Overall it’s a good experience, she does a good job… Hank has been really good about taking care of it for us.',
        bio: 'Lea L, Clearwater, MN',
    },
    {
        review: 'The drivers I’ve had have all been very good. I enjoy having the company because I live alone. I really appreciate all of the drivers and their attitudes, they were just great. I’d give Hank a good rating, they’re well worth calling and they’re very accommodating.',
        bio: 'Judi H, Lone Tree, CO',
    },
    {
        review: '[Hank has] been excellent. [The drivers] have been very prompt and professional. [They are] knowledgable, and also provide protection – the drivers always have their masks on. They assist with my portable walker… They are helpful as well.',
        bio: 'Jacqueline W, Jacksonville, NC',
    },
    {
        review: "Hank is a real treat and an easy, easy benefit to my life. I didn't realize that making meals gets to be a burden. I'm 78 years old, and I'm tired of cooking and picking things up.",
        bio: 'Donna G, Chico, CA',
    },
    {
        review: 'I was very pleased with to find a service that can allow me to ease some stressors for her, even though I’m not physically near. We will definitely be using Hank again!',
        bio: 'Caitlin T, Azle, TX',
    },
];
var Testimonial = function (_a) {
    var review = _a.review, bio = _a.bio, inRow = _a.inRow;
    return (react_1.default.createElement(grid_1.Container, { center: true, direction: "column", px: inRow ? 2.5 : 0, pb: inRow ? 5 : 0, style: { maxWidth: '360px' } },
        react_1.default.createElement(Stars_1.default, null),
        react_1.default.createElement(typography_1.P, { py: 2, lineHeight: 150, center: true }, review),
        react_1.default.createElement(typography_1.P, { weight: 700, center: true }, bio)));
};
var TestimonialCards = function () {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(spacing_1.Div, { hideOver: "lg" },
            react_1.default.createElement(Carousel_1.default, { items: [
                    testimonials.slice(0, 2),
                    testimonials.slice(2, 4),
                    testimonials.slice(4, 5),
                ].map(function (pair, idx) { return (react_1.default.createElement(grid_1.Container, { center: true, direction: "column", key: idx }, pair.map(function (t, tidx) { return (react_1.default.createElement(spacing_1.Div, { key: tidx, pt: tidx % 2 === 1 ? 5 : 0 },
                    react_1.default.createElement(Testimonial, __assign({}, t)))); }))); }) })),
        react_1.default.createElement(spacing_1.Div, { hideUnder: "lg" }, [testimonials.slice(0, 3), testimonials.slice(3, 5)].map(function (row, rowIdx) { return (react_1.default.createElement(grid_1.Container, { align: "center", justify: "center", hideUnder: rowIdx > 0 ? 'sm' : undefined, key: "row-".concat(rowIdx) }, row.map(function (testimonial, idx) { return (react_1.default.createElement(Testimonial, __assign({ key: idx, inRow: true }, testimonial))); }))); }))));
};
exports.default = TestimonialCards;
//# sourceMappingURL=Testimonials.js.map